import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { MOBILE_WIDTH, TABLET_WIDTH } from "../../../../../utils/HelperStyles";
import StyledButton from "../../../../StyledButton";
import StyledInput from "../../../../StyledInput";

const styledModalScrollbar = css`
  /* ::-webkit-scrollbar {
    width: 7px;
  }

  ::-webkit-scrollbar-track {
    background: #dcdfe3;
  }

  ::-webkit-scrollbar-thumb {
    background: #848688;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555b5f;
  } */
`;

export const ActivateLeftContainer = styled.div`
  border-right: 1px solid #c9c9c9;
  padding: 0px 25px;
  width: 100%;

  @media (max-width: ${TABLET_WIDTH}) {
    border-right: none;
    margin-top: 50px;
    margin-bottom: 50px;
  }
`;

export const ActivateAccountContainer = styled.div`
  padding-bottom: 35px;
`;

export const ActivationTitle = styled.div`
  font: normal normal 900 18px/22px Lato;
  padding-bottom: 4px;
  color: #111111;
`;

export const ActivationSubtitle = styled.div`
  font: normal normal normal 14px/16px "Helvetica Neue";
  color: #555b5fa3;
  padding-bottom: 19px;
`;

export const CardAdsContainer = styled.div`
  width: 100%;
  background: #f6f6f7 0% 0% no-repeat padding-box;
  border-radius: 8px;
`;

export const CardAdsHeader = styled.div`
  display: grid;
  grid-template-columns: max-content max-content;
  justify-content: space-between;
  font: normal normal bold 16px/19px Lato;
  padding: 14px 20px 12px 20px;
  color: #111111;
`;

export const Price = styled.div`
  font: normal normal 900 21px/18px Lato;
  color: #111111;
  text-align: right;

  > span {
    font: normal normal normal 15px/18px Lato;
    color: #555b5f;
    margin-left: 3px;
  }
`;

export const DollarSign = styled.span`
  display: inline-block;
  vertical-align: top;
  text-align: left;
  font: normal normal normal 16px/19px Lato;
  color: #555b5f;
`;

export const CardsAdsContent = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  padding-bottom: 22px;
`;

export const CardAdsItems = styled.div`
  display: inline-flex;

  font: normal normal normal 14px/26px Lato;
  color: #111111;

  > span {
    margin-left: 7px;
  }
`;

export const PurchaseContainer = styled.div`
  padding-bottom: 35px;
`;

export const PurchaseAdditionalTitle = styled.div`
  font: normal normal 900 16px/19px Lato;
  padding-bottom: 12px;
`;

export const CardAdditionalContainer = styled.div`
  font: normal normal normal 13px/16px Lato;
  color: #555b5f;

  display: grid;
  grid-template-columns: 1fr 1fr 1fr;

  padding: 13px 20px 18px 20px;
  width: 100%;
  height: 80px;

  background: #f6f6f7 0% 0% no-repeat padding-box;
  border-radius: 8px;

  > div > p {
    margin: 0;
    margin-top: 7.89px;
    margin-bottom: 13px;
    font: normal normal bold 18px/22px Lato;
    color: #111111;
  }

  div:last-child {
    text-align: right;
  }
`;

export const AdditionalLair = styled.div`
  font: normal normal bold 16px/18px "Helvetica Neue";
  text-align: center;
  color: #5fa200;

  padding-top: 12px;
`;

export const TotalAmountContainer = styled.div`
  background: #111111 0% 0% no-repeat padding-box;
  border-radius: 8px;
  width: 100%;
  height: 58px;

  padding: 18px 20px 15px 20px;
`;

export const InputQuantity = styled(StyledInput)`
  margin-top: 7.9px;
  width: 79px;
  height: 30px;
  border: 1px solid #c9c9c9;
  border-radius: 5px;
`;

export const TotalAmountContent = styled.div`
  display: grid;
  grid-template-columns: max-content max-content;
  justify-content: space-between;
  font: normal normal bold 16px/19px Lato;

  div {
    font: normal normal 900 25px/21px Lato;
    color: #fff !important;
  }

  div:first-child {
    font: normal normal bold 16px/19px Lato;
  }

  div > span {
    color: #c6cbd0 !important;
  }
`;

export const CreditCardContainerInfo = styled.form`
  display: grid;
  grid-template-rows: max-content max-content max-content;

  overflow-y: auto;
  ${styledModalScrollbar}
  width: 100%;
  padding: 0px 40px;

  @media (max-width: ${MOBILE_WIDTH}) {
    overflow-y: unset;
    margin-top: 30px;
    padding: 0px 20px;
    margin-bottom: 40px;
  }
`;

export const CreditCardDetails = styled.div`
  padding-bottom: 38px;
  border-bottom: 1px solid #cccccc;

  @media (max-width: ${MOBILE_WIDTH}) {
    padding-bottom: 25px;
  }
`;

export const SectionTitle = styled.div`
  font: normal normal 900 18px/22px Lato;
  color: black;
  color: #111111;
  font-weight: 900;
  padding-bottom: 20px;
`;

export const Row = styled.div`
  margin-bottom: 20px;
`;

export const PaymentFieldName = styled.div`
  text-align: left;
  font: normal normal bold 16px/26px Lato;
  letter-spacing: 0px;
  color: #2f2f2f;
  padding-bottom: 10px;
`;

export const InputPayment = styled(StyledInput)<{ error: boolean }>`
  border: 1px solid ${(props) => (props.error ? "#eb1c26" : "#dcdfe3")};
  /* ${(props) => props.error && "color: #eb1c26;"} */
  border-radius: 4px;
  margin-top: 5.9px;
  padding-top: 6px;
  padding-bottom: 7px;
  height: 46px;
  width: 100%;
  :focus {
    box-shadow: 0px 0px 2.5px 0px rgba(0, 0, 0, 0.5);
  }
`;

export const InputPaymentContainer = styled.div<{
  error: boolean;
  focused: boolean;
}>`
  box-shadow: ${(props) =>
    props.focused ? "0px 0px 2.5px 0px rgba(0,0,0,0.5)" : "none"};
  border: 1px solid ${(props) => (props.error ? "#eb1c26" : "#dcdfe3")};
  border-radius: 4px;
  height: 46px;
  padding: 0px 12px;
`;

export const SplitRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 15px;

  padding-bottom: 20px;
`;

export const BillingContainer = styled.div`
  padding: 38px 0px;
  border-bottom: 1px solid #e5e5e5;

  @media (max-width: ${MOBILE_WIDTH}) {
    padding: 25px 0px;
  }
`;

export const BillingAddressContainer = styled.div`
  border: 1px solid #e5e5e5;
  background-color: #f6f6f7;
  border-radius: 4px;
  margin-top: 5.9px;
  padding: 15px 25px;
  display: flex;
  font-size: 14px;
`;

export const AddressTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const AddressDescription = styled.div`
  font: normal normal 500 15px/26px Lato;
`;

export const AddressEditButton = styled.div`
  font-weight: normal;
  font-size: 16px;
  color: #2569b8;
  cursor: pointer;
  place-self: center;
  :hover {
    text-decoration: underline;
  }
`;

export const SameAddress = styled.div`
  padding-top: 20px;
`;

export const ShippingContainer = styled.div`
  padding: 38px 0px;
  border-bottom: 1px solid #e5e5e5;

  @media (max-width: ${MOBILE_WIDTH}) {
    padding: 25px 0px;
  }
`;

export const ShippingTitle = styled.div`
  font: normal normal 900 18px/22px Lato;
  color: black;
  color: #111111;
  font-weight: 900;
  padding-bottom: 5px;
`;

export const ShippingAddressContainer = styled.div<{
  isFirstEditShippingAddress?: boolean;
}>`
  border: 1px solid #e5e5e5;
  background-color: #f6f6f7;
  border-radius: 4px;
  margin-top: 5.9px;
  padding-top: 6px;
  padding-bottom: 7px;
  padding: 15px 25px;
  display: flex;
  flex-direction: ${(props) =>
    props.isFirstEditShippingAddress ? "row" : "column"};
  font-size: 14px;
`;

export const ShippingButtons = styled.div`
  display: flex;

  > button {
    font: normal normal bold 15px/18px Lato;
  }

  > button:first-child {
    margin-right: 10px;
  }
`;

export const ModalFooterContainer = styled.div`
  display: grid;
  grid-template-columns: max-content max-content;
  grid-column-gap: 12px;
  padding-top: 40px;
  padding-bottom: 26px;
  justify-content: end;
`;

export const FooterButton = styled(StyledButton)`
  border-radius: 20px !important;
`;
